<script>
import Grazing from '@/grazing/components/Grazing.vue';

export default {
  components: {
    Grazing,
  },

  props: {
    farmId: { type: String, required: true },
    grazingId: { type: String, required: true },
  },
}
</script>

<template>
  <api-loader
    method="get"
    :url="`v1/grazings/${grazingId}`"
    v-slot="{result: grazing}">

    <grazing :grazing="grazing" />

  </api-loader>
</template>



// WEBPACK FOOTER //
// src/grazing/views/GrazingView.vue